import React, {memo} from "react";
import cn from "classnames";

export const IconDiamond = memo(({color, addClass}) => {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      className={cn({[addClass]: !!addClass})}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9 5.70805L15.9 1.70805C15.823 1.60505 15.709 1.53605 15.582 1.51505L9.58199 0.515051C9.52799 0.506051 9.47199 0.506051 9.41799 0.515051L3.41799 1.51505C3.29099 1.53605 3.17699 1.60505 3.09999 1.70805L0.0999905 5.70805C-0.0430095 5.89905 -0.0310095 6.16505 0.127991 6.34205L9.12799 16.3421C9.22299 16.4471 9.35799 16.5081 9.49999 16.5081C9.64199 16.5081 9.77699 16.4481 9.87199 16.3421L18.872 6.34205C19.032 6.16405 19.044 5.89905 18.9 5.70805ZM12.786 5.50805L9.49999 14.5451L6.21399 5.50805H12.786ZM6.70699 4.50805L9.49999 1.71505L12.293 4.50805H6.70699ZM10.957 1.75805L14.655 2.37405L13.422 4.22305L10.956 1.75805H10.957ZM5.57799 4.22305L4.34499 2.37405L8.04299 1.75805L5.57799 4.22305ZM4.66999 4.66405L1.68499 5.26105L3.47599 2.87305L4.66999 4.66405ZM5.17699 5.58305L8.15099 13.7621L1.45899 6.32605L5.17699 5.58205V5.58305ZM13.823 5.58305L17.541 6.32705L10.849 13.7631L13.823 5.58405V5.58305ZM14.33 4.66405L15.524 2.87305L17.315 5.26105L14.33 4.66405Z"
        fill={color || "#000"}
      />
    </svg>
  );
});
